module.exports = __webpack_public_path__ + "img/fair.58fb6753.png";